import api from './api'

export const managedDeviceGroupsApi = {
  // Get groups by level (with optional parent filter).
  // typeId recorta pela aba (tipo de device); omitido = todas as abas.
  getByLevel: async (tenantId, parentGroupId = null, typeId = null) => {
    const params = {}
    if (parentGroupId) params.parentGroupId = parentGroupId
    if (typeId) params.typeId = typeId
    const response = await api.get(`/tenants/${tenantId}/managed-device-groups`, { params })
    return response.data
  },

  // Get group tree for tenant (typeId recorta pela aba)
  getTree: async (tenantId, typeId = null) => {
    const params = typeId ? { typeId } : {}
    const response = await api.get(`/tenants/${tenantId}/managed-device-groups/tree`, { params })
    return response.data
  },

  // Get group by ID
  getById: async (id) => {
    const response = await api.get(`/managed-device-groups/${id}`)
    return response.data
  },

  // Create new group
  create: async (tenantId, data) => {
    const response = await api.post(`/tenants/${tenantId}/managed-device-groups`, data)
    return response.data
  },

  // Update existing group
  update: async (id, data) => {
    const response = await api.put(`/managed-device-groups/${id}`, data)
    return response.data
  },

  // Delete group
  delete: async (id) => {
    await api.delete(`/managed-device-groups/${id}`)
  },

  // Move group to different parent (or to root level)
  moveGroup: async (id, parentGroupId) => {
    await api.patch(`/managed-device-groups/${id}/parent`, { parentGroupId: parentGroupId ?? null })
  },

  // Helper functions for group management
  getRootGroups: async (tenantId) => {
    return await managedDeviceGroupsApi.getByLevel(tenantId, null)
  },

  getChildGroups: async (tenantId, parentGroupId) => {
    return await managedDeviceGroupsApi.getByLevel(tenantId, parentGroupId)
  },

  // Group filtering helpers for backward compatibility
  getRouterGroups: async (tenantId, parentGroupId = null) => {
    // In unified model, groups can contain both device types
    // This helper maintains compatibility but returns all groups
    return await managedDeviceGroupsApi.getByLevel(tenantId, parentGroupId)
  },

  getHostGroups: async (tenantId, parentGroupId = null) => {
    // In unified model, groups can contain both device types
    // This helper maintains compatibility but returns all groups
    return await managedDeviceGroupsApi.getByLevel(tenantId, parentGroupId)
  }
}

// Maintain backward compatibility with legacy group APIs (temporary)
// These should be removed in Phase 4 cleanup
export const routerGroupsApi = {
  getByLevel: managedDeviceGroupsApi.getRouterGroups,
  getTree: managedDeviceGroupsApi.getTree,
  getById: managedDeviceGroupsApi.getById,
  create: managedDeviceGroupsApi.create,
  update: managedDeviceGroupsApi.update,
  delete: managedDeviceGroupsApi.delete,
  moveGroup: managedDeviceGroupsApi.moveGroup
}

export const hostGroupsApi = {
  getByLevel: managedDeviceGroupsApi.getHostGroups,
  getTree: managedDeviceGroupsApi.getTree,
  getById: managedDeviceGroupsApi.getById,
  create: managedDeviceGroupsApi.create,
  update: managedDeviceGroupsApi.update,
  delete: managedDeviceGroupsApi.delete,
  moveGroup: managedDeviceGroupsApi.moveGroup
}